import axios from 'axios'
import { Filter } from '../../components/_WMS/FilterComponent'
import { eTypePosition } from '../../enums/eTypePosition'
import { ApiConfig } from '../../config/api'
import { RestockOrderCreate } from './Entities/Stock'

export const getStockReserve = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: string }
) => {
  const url = new URL(
    `${ApiConfig.StockApi}/GetDetail?typePositionId=${eTypePosition.Reserva}&isExternalStorage=true`
  )

  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const postRestockOrder = (dto: RestockOrderCreate) => {
  const url = new URL(`${ApiConfig.RestockOrderApi}`)

  return axios.post(url.toString(), dto)
}
